'use strict';

var $u = require('../utilities');
var $d = require('../dependency');
var _ = $d._;
var moment = $d.moment;

exports.druidResponseParser = druidResponseParser;

function druidResponseParser(context, config, next) {
    var apiResponse = context.apiResponse,
      parsedResponse = [],
      tempResponseObj,
      userBaseTimeString,
      duration,
      customDurationContext;
    /**
     since apiResponse is an array;we need to parse each seperately
     and return an array to pass furthur.

     Note: Extra Level of array encapsulation (over the druid response format)
     is due to resolving array of ajax responses.

     topN Sample:
     ***********
     apiResponse = [[
     {
         "timestamp": "YYYY-MM-DDT00:00:00.000Z",
         "result": [
             {
                 "someMetric": n,
                 "someDimension": "xyz"
             },
             {
                 .
                 .
             }
         ]
     }
     ]]

     TimeSeries Sample:
     *****************
     apiResponse = [[
     {
         "timestamp": "YYYY-MM-DDT00:00:00.000Z",
         "result": {
             "someMetric": n
         }
     },
     {
         .
         .
         .
         .
     }
     ]]

     GroupBy Sample:
     ***************
     apiResponse = [[
     {
         "version": "v1",
         "timestamp": "YYYY-MM-DDT00:00:00.000Z",
         "event": {
             "someMetric": n,
             "dimensionGroupedOver": "xyz"
         }
     },
     {
         .
         .
         .
     }
     ]]
     */

    _.forEach(apiResponse, function (inputResponseObject, index) {
        tempResponseObj = {};
        customDurationContext = {};
        if (context.dataConfig[index].queryType === 'topN') {
            //Get the actual response object.
            inputResponseObject = inputResponseObject[0];

            //Set the timestamp; It maybe need later.
            if (inputResponseObject) {
                tempResponseObj.timestamp = inputResponseObject.timestamp;
            }

            //Iterate over the fields to return.
            _.forEach(context.fields, function (field) {
                tempResponseObj[field] = [];
                //Iterate over the results object to get the top N values.
                if (inputResponseObject) {
                    _.forEach(inputResponseObject.result, function (resultObj) {
                        tempResponseObj[field].push(resultObj[field]);
                    });
                }
            });

        } else if (context.dataConfig[index].queryType === 'timeseries') {

            userBaseTimeString = moment(context.baseTime).toISOString();

            if(context.durationFilterValue === 'custom'){
                customDurationContext.granularity = context.granularity;
                customDurationContext.interval = context.intervals[0][0];
            }

            $u.generic.zeroFillEmptyBuckets(
                userBaseTimeString,
                context.durationFilterValue,
                inputResponseObject,
                _.difference(context.fields, ['timestamp']),
                customDurationContext
            );

            _.forEach(context.fields, function (field) {
                tempResponseObj[field] = _.map(inputResponseObject, function (responseObj) {
                    if (field === 'timestamp') {
                        return responseObj[field];
                    } else {
                        return responseObj.result[field];
                    }
                });
            });

        } else if (context.dataConfig[index].queryType === 'groupBy') {
            _.forEach(context.fields, function (field) {
                tempResponseObj[field] = _.map(inputResponseObject, function (responseObj) {
                    if (field === 'timestamp') {
                        return responseObj[field];
                    } else {
                        return responseObj.event[field];
                    }
                });
            });
        }

        parsedResponse.push(tempResponseObj);

    });

    /**
     Sample:
     *******
     parsedResponse = [
     // for API call 1
     {
         timestamp:[date1,date2,date3],
         field1: [f1,f2,f3],
         field2: [g1,g2,g3]
     },
     // for API call 2
     {
         .
         .
         .
     }
     ]
     */
    context.apiParsedResponseList = parsedResponse;
    next();
}